module.exports = __webpack_public_path__ + "img/code.a6b9d46a.png";